<template>
  <div class="header mb-3">
    <h3 class="sr-only">Users List</h3>

    <label class="search">
      <span class="sr-only">Search</span>
      <font-awesome-icon :icon="['fas', 'search']" class="icon alt" />
      <input
        type="text"
        :value="search"
        placeholder="Search name or email"
        @input="setSearch"
      />
    </label>
    <label class="sort">
      <span class="sr-only">
        list is sorted by {{ sortByOption.label }}
      </span>
      <select :value="sortBy" @input="setSortBy">
        <option
          v-for="option in sortByOptions"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </label>
    <div class="dash-button-group">
      <button
        :class="{ active: creditDisplayType === 'individual' }"
        :disabled="creditDisplayType === 'individual'"
        @click="setCreditDisplayType('individual')"
      >
        Individual
      </button>
      <button
        :class="{ active: creditDisplayType === 'group' }"
        :disabled="creditDisplayType === 'group'"
        @click="setCreditDisplayType('group')"
      >
        Wellbeing Workshop
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchTimeout: null,
    };
  },

  inject: ['studentDetailsReport'],

  computed:{
    creditDisplayType() {
      return this.studentDetailsReport.creditDisplayType;
    },
    search() {
      return this.studentDetailsReport.parameters.search;
    },
    sortByOption() {
      return this.sortByOptions.find((o) => o.value === this.sortBy);
    },
    sortByOptions() {
      return this.studentDetailsReport.parameterOptions.sortBy;
    },
    sortBy() {
      return this.studentDetailsReport.sortBy;
    },
  },
  methods:{
    async setCreditDisplayType(type) {
      await this.studentDetailsReport.setCreditDisplayType(type);
      this.$forceUpdate();
    },
    setSearch(e) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }

      this.searchTimeout = setTimeout(() => {
        this.studentDetailsReport.setParameters({ search: e.target.value });
      }, 500);
    },
    setSortBy(e) {
      this.studentDetailsReport.setParameters({ pageToken: e.target.value });
    }
  }
}
</script>

<style  lang="scss" scoped>
.search,
.sort {
  width: 45%;
  background: #fff;
  height: 45px;
  border-radius: 8px;
  border: 1px solid #d1d1d1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;
  margin-right: 2%;

  .icon {
    font-size: 18px;
    margin-right: 8px;
  }

  input {
    border: 0;
    height: 80%;
    background: transparent;
    flex: 1;
    margin: 0;
    font-size: 14px;
  }

  select {
    width: 100%;
    height: 80%;
    background: transparent;
    border: none;
    font-weight: 500;
    font-size: 14px;
  }

  &:hover,
  &:focus {
    box-shadow: 0 2px 4px rgb(0 0 0 / 18%);
    border-color: #bababa;
  }
}

.dash-button-group {
  min-width: 144px;

  button {
    font-weight: normal;
    font-size: 14px;
    padding: 0 10px;
  }
}

</style>
